<template>
  <el-dialog title="课件详情" :visible.sync="visible" width="1000px" class="file-model" top="0">
    <div style="text-align: right;">
      <el-button @click="downloadAll()" type="primary" size="small" >下载全部</el-button>
    </div>
    <div class="file-list">
      <div class="file-item" v-for="(item,i) in fileList" :key="i">
        <div class="box">
          <fileType className="imgS" :url="item.url"></fileType>
          <div class="title">{{item.name}}</div>
          <div class="size">{{item.size}}</div>
          <div class="time">{{item.createTime | timeNum(10)}}</div>
        </div>
        <div class="box">
          <el-button size="small" @click="lookFile(item)" v-if="checkFileType(item.url,['.pdf','.png','.jpg'])">预览</el-button>
          <el-button size="small" type="primary" @click="downloadFile(item)">下载</el-button>
        </div>
        
      </div>
    </div>
  </el-dialog>
</template>
<script>
import fileType from "./fileType";
export default {
  props: {},
  data: () => ({
    visible: false,
    fileList: [{}],
    formData: {},
  }),
  components: {fileType},
  created() {},
  methods: {
    open(data = {}) {
      this.formData = Object.assign({}, data);
      const loading = this.$notice.loading();
      this.$http({
        url: '/master/information/queryCoursewareList',
        type: 'get',
        params: {
          articleId: data.id,
        }
      }).then((res)=>{
        if(res.data.length==1){
          const url = res.data[0].url;
          if(this.checkFileType(url,['.pdf','.png','.jpg'])){
            window.open(url);
          }else if(this.checkFileType(url,'.xls')){
            this.$notice.msg("Excel格式目前暂不支持预览，已为您自动下载")
            this.$tools.daochu2(url)
          }else{
            this.$tools.daochu2(url)
          }
          return;
        }
        this.visible = true;
        this.fileList = res.data;
      }).finally(() => {
        loading.close();
      });
    },
    // 下载单个文件
    downloadAll() {
      const list = [
        {
          type: 3,
          articleId: this.formData.id,
        }
      ];
      this.$tools.daochu('/master/information/downloadFile',{list},'put');
    },
    // 下载单个文件
    downloadFile(item) {
      this.$tools.daochu2(item.url)
    },
    // 预览文件
    lookFile(item){
      window.open(item.url);
    },
    // 验证文件类型
    checkFileType(url, type) {
      if(!url) {
        return false;
      }
      url = url.toLowerCase()
      if(typeof type == "string" && url.includes(type)){
        return true;
      }
      if(typeof type == "object"){
        const fileType = url.substring(url.lastIndexOf("\."));
        if(type.includes(fileType)){
          return true;
        }
      }
      return false;
    },
  }
};
</script>
<style lang="scss" scoped>
@import "./fileModel.scss";
</style>
